import React from 'react'
import { Link as ReactLink } from 'react-router-dom'
import { createUrl } from './urls'
import type { RouteNames, UrlParams } from './urls'

type LinkProps = {
  name: RouteNames
  params: UrlParams | string
  shouldReload?: boolean
  className?: string
  onLog?: () => void
}

export const InternalLink: React.FC<React.PropsWithChildren<LinkProps>> = ({
  name,
  params,
  className,
  shouldReload = false,
  children,
  onLog,
}) => {
  const target = typeof params === 'string' ? params : createUrl(name, params)
  return (
    <ReactLink
      className={className}
      style={{ textDecoration: 'none' }}
      to={target}
      reloadDocument={shouldReload}
      onClick={() => {
        if (onLog) {
          onLog()
        }
      }}
    >
      {children}
    </ReactLink>
  )
}
